// Resolves a product image URL. If the value is a relative path (starts with '/'),
// it prepends the backend base URL so backend-hosted static assets work in every environment.
// External CDN URLs (starting with 'http') are returned unchanged.
export function resolveImage(url) {
    if (!url) return url;
    if (url.startsWith('/')) {
        return `${process.env.REACT_APP_BACKEND_URL}${url}`;
    }
    return url;
}
